import { useState, useEffect } from 'react';
import logo from '../logo.png';

const sections = ['Home', 'Films', 'Books', 'About', 'Press', 'Contact'];
export const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const updateSectionFromHash = () => {
      setActiveSection(window.location.hash.replace('#', '') || 'home');
    };

    updateSectionFromHash(); // Initial run
    window.addEventListener('hashchange', updateSectionFromHash);
    return () =>
      window.removeEventListener('hashchange', updateSectionFromHash);
  }, []);

  const handleSmoothScroll = (e, id, offset = 40) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      window.history.pushState(null, '', `#${id}`);
      setActiveSection(id);
    }
  };

  return (
    <header className="flex justify-center px-5 xl:px-0 fixed top-2 left-1/2 transform -translate-x-1/2 z-50 w-full">
      <nav className="bg-[linear-gradient(90deg,rgba(255,255,255,0.005)_0%,rgba(255,255,255,0.005)_100%)] backdrop-blur-[40px] rounded-full pr-3 py-2 shadow-lg flex items-center justify-between w-full pl-16 max-w-[1146px]">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <a href="/">
            <img src={logo} alt="MSP" className="w-16 h-16 rounded-full" />
          </a>
        </div>

        {/* Desktop Nav */}
        <div className="flex items-center">
          <ul className="hidden lg:flex gap-1 text-white font-semibold tracking-wide text-xs md:text-sm">
            {sections.map((sec) => {
              const secLower = sec.toLowerCase();
              const isActive =
                typeof window !== 'undefined' &&
                window.location.pathname === '/' &&
                activeSection === secLower;

              const scrollableSections = ['contact', 'about', 'press', 'books'];

              return (
                <li key={sec} className="relative group">
                  {/* {secLower === 'films' || secLower === 'books' ? ( */}
                  {secLower === 'films' ? (
                    <a
                      href={`/${secLower}`}
                      className={`hover:text-[#F2BA35] block hover:bg-[rgba(255,255,255,0.1)] rounded-full py-[14px] px-4 transition-all duration-400 ease-ease-custom font-cinzel text-base ${
                        isActive ? 'text-[#F2BA35]' : ''
                      }`}
                    >
                      <span className="transition-all duration-400 group-hover:-translate-y-1 block">
                        {sec.toUpperCase()}
                      </span>
                    </a>
                  ) : (
                    <a
                      href={`/${secLower === 'home' ? '' : `#${secLower}`}`}
                      className={`hover:text-[#F2BA35] block hover:bg-[rgba(255,255,255,0.1)] rounded-full py-[14px] px-4 transition-all duration-400 font-cinzel text-base ${
                        isActive ? 'text-[#F2BA35]' : ''
                      }`}
                      onClick={(e) => {
                        if (window.location.pathname !== '/') {
                          e.preventDefault();
                          window.location.href = `/${
                            secLower === 'home' ? '' : `#${secLower}`
                          }`;
                        } else if (scrollableSections.includes(secLower)) {
                          handleSmoothScroll(e, secLower);
                        }
                      }}
                    >
                      <span className="transition-all duration-400 group-hover:-translate-y-1 block">
                        {sec.toUpperCase()}
                      </span>
                    </a>
                  )}

                  <div
                    className={`absolute pointer-events-none -bottom-[-3px] left-1/2 transform -translate-x-1/2 w-9 h-0.5 rounded-[1px] transition-all duration-300 ${
                      isActive
                        ? 'bg-[#F2BA35]'
                        : 'bg-transparent group-hover:bg-[#F2BA35]'
                    }`}
                  ></div>
                </li>
              );
            })}
          </ul>

          {/* SUPPORT US Button */}
          <button
            className={`hidden lg:inline-block ml-4 lg:ml-7 font-bold px-3 md:px-5 rounded-full shadow transition leading-[48px] text-base font-cinzel ${
              activeSection === 'support'
                ? 'bg-[#F2BA35] text-white'
                : 'bg-white text-black hover:bg-[#F2BA35] hover:text-white'
            }`}
            onClick={(e) => {
              if (window.location.pathname === '/') {
                handleSmoothScroll(e, 'support');
              } else {
                e.preventDefault();
                window.location.href = '/#support';
              }
            }}
          >
            SUPPORT US
          </button>

          {/* Hamburger */}
          <button
            className="lg:hidden text-white w-[42px] h-[42px] flex items-center justify-center bg-[#473D34] rounded-full"
            aria-label="Toggle navigation"
            onClick={() => setNavOpen(!navOpen)}
          >
            <svg
              className="w-7 h-7"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          {/* Mobile Nav */}
          {navOpen && (
            <div className="absolute top-full left-0 w-full bg-[#421B03] rounded-b-2xl shadow-md lg:hidden flex flex-col items-center py-2 z-50 animate-fade-in">
              <ul className="flex flex-col gap-3 text-white font-semibold tracking-wide text-base w-full text-center">
                {sections.map((sec) => {
                  const secLower = sec.toLowerCase();
                  const isActive =
                    typeof window !== 'undefined' &&
                    window.location.pathname === '/' &&
                    activeSection === secLower;

                  return (
                    <li key={sec} className="relative">
                      {secLower === 'films' || secLower === 'books' ? (
                        <a
                          href={`/${secLower}`}
                          className={`block py-2 hover:text-[#F2BA35] transition-colors ${
                            isActive ? 'text-[#F2BA35]' : ''
                          }`}
                          onClick={() => setNavOpen(false)}
                        >
                          {sec.toUpperCase()}
                        </a>
                      ) : (
                        <a
                          href={`/${secLower === 'home' ? '' : `#${secLower}`}`}
                          className={`block py-2 hover:text-[#F2BA35] transition-colors ${
                            isActive ? 'text-[#F2BA35]' : ''
                          }`}
                          onClick={(e) => {
                            setNavOpen(false);
                            if (window.location.pathname !== '/') {
                              e.preventDefault();
                              window.location.href = `/${
                                secLower === 'home' ? '' : `#${secLower}`
                              }`;
                            } else {
                              handleSmoothScroll(e, secLower);
                            }
                          }}
                        >
                          {sec.toUpperCase()}
                        </a>
                      )}
                      {isActive && (
                        <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-1 bg-[#F2BA35] rounded"></div>
                      )}
                    </li>
                  );
                })}
              </ul>

              {/* Mobile SUPPORT US */}
              <button
                className={`mt-2 text-sm font-bold px-5 py-2 rounded-full shadow transition w-5/6 mx-auto ${
                  activeSection === 'support'
                    ? 'bg-[#F2BA35] text-white'
                    : 'bg-white text-black hover:bg-[#F2BA35] hover:text-white'
                }`}
                onClick={(e) => {
                  setNavOpen(false);
                  if (window.location.pathname === '/') {
                    handleSmoothScroll(e, 'support');
                  } else {
                    e.preventDefault();
                    window.location.href = '/#support';
                  }
                }}
              >
                SUPPORT US
              </button>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};
